<template>
  <div class="answer-content">
    <div class="main-wrapper-header">
      <div class="header-left">
        <span>您当前所在位置 >  </span>
        <el-breadcrumb separator=">" style="margin-left: 4px" >
          <el-breadcrumb-item>实操训练</el-breadcrumb-item>
          <el-breadcrumb-item>训练名称</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header-right">
        <el-button @click="toBack" type="primary">返回</el-button>
      </div>
    </div>
    <el-table :data="answerTable" style="width: 100%; flex: 1;margin-top: 20px" height="1%" size="medium"
              :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#eee',fontSize: '16px',height:'60px'}"
              class="customTable" :cell-style="{fontSize: '16px',color: '#333',height: '70px'}">
      <el-table-column prop="frequency" label="训练次数" align="left">
        <template slot-scope="scope">
          <span>第{{toChinesNum(scope.row.index)}}次</span>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="分值">
        <template slot-scope="scope">
          <span>{{scope.row.score}}分</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <div class="link-list">
            <el-link type="success" :underline="false" @click="viewDetail(scope.row.log_id,scope.row.index)">查看详情</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="pages-center"
        :current-page="answerPages.currentPageNum"
        :page-size="answerPages.eachPageNum"
        layout="prev, pager, next, jumper"
        :total="answerPages.total"
        @current-change="answerCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {examStuDrillKefuDetail} from '@/utils/apis'
export default {
  name: "AnswerDetail",
  data() {
    return {
      answerTable: [],
      //分页
      answerPages: {
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0
      },
    }
  },
  mounted() {
    this.getExamStuDrillKefuDetail()
  },
  methods: {
    getExamStuDrillKefuDetail(){
      let params = {
        id:this.$route.query.id,
        course_id:this.$route.query.course_id,
        chapter_id:this.$route.query.chapter_id,
        node_id:this.$route.query.lesson_id,
        paging:1,
        page:this.answerPages.currentPageNum,
        pageSize:this.answerPages.eachPageNum
      }
      examStuDrillKefuDetail(params).then((res)=>{
        this.answerTable = res.data.data;
        this.answerPages.total = res.data.total;
      }).catch((err)=>{
        console.log('err',err)
      })
    },
    //查看详情
    viewDetail(logId,number) {
      let numStr = this.toChinesNum(number);
      this.$router.push({
        path: '/student/trainCenter/lookDetail',
        query: {
          logId,
          numStr
        }
      })

    },
    toBack(){
      this.$router.go(-1)
    },
    //切换分页
    answerCurrentChange(val) {
      this.answerPages.currentPageNum = val;
      this.getExamStuDrillKefuDetail()
    },
    // 将数字转为大写
    toChinesNum(num){
      let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //changeNum[0] = "零"
      let unit = ["", "十", "百", "千", "万"];
      num = parseInt(num);
      let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (let i = 0; i < strArr.length; i++) {
          newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
        }
        return newNum;
      }
      let overWan = Math.floor(num / 10000);
      let noWan = num % 10000;
      if (noWan.toString().length < 4) noWan = "0" + noWan;
      return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb{
  .el-breadcrumb__inner{
    color: #2C95FF;
  }
  .el-breadcrumb__separator{
    color: #333333;
    font-weight: 500;
  }
}
.answer-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  .main-wrapper-header{
    padding: 0px 0 14px;
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #F1F5FF;
    .header-left{
      display: flex;
      align-items: center;
      span{
        line-height: 1;
      }
    }
  }
}
</style>